import { createFileRoute } from '@tanstack/react-router'
import { RatesRoute } from '@/features/rates/components/rates'

export const Route = createFileRoute(
  '/_authenticated/dashboard/houses/$houseId/rooms/$roomId/rates',
)({
  component: RatesRoute,
})
